import { useApp, type Modal, type CoachingModal } from '@/core/state/appStore'
import { getJourneyPosition } from '@/core/data/coachings'
import { phaseTabBounds, positionsForModal, aufgabeForName } from '@/core/data/aufgabe'
import { descriptionFor } from '@/variants'

const NON_PHASE_TABS: Partial<Record<Modal, string>> = {
  erstgespraech: 'checkliste',
  'verbis-lebenslauf': 'hochladen',
  dokument: 'form',
}

function defaultTab(target: Modal): string {
  const tab = ['azav', 'vergabe']
    .flatMap((variant) => Object.values(descriptionFor(variant).aufgabe))
    .find((entry) => entry.landing?.modal === target)?.landing?.tab ?? NON_PHASE_TABS[target]
  if (!tab) throw new Error(`No landing tab for modal "${target}"`)
  return tab
}

export function phaseLandingTabFor(target: Modal, aufgabeName: string | null | undefined): string {
  const bounds = phaseTabBounds(target)
  if (!bounds) return defaultTab(target)
  const entry = aufgabeForName(aufgabeName)
  if (!entry) return defaultTab(target)
  if (entry.landing?.modal === target) return entry.landing.tab
  const span = positionsForModal(target)
  if (entry.position > span[span.length - 1]) return bounds.last
  return bounds.first
}

export async function phaseLandingTab(target: Modal, coachingId: string | null): Promise<string> {
  if (!coachingId || !phaseTabBounds(target)) return defaultTab(target)
  try {
    const { aufgabeName } = await getJourneyPosition(coachingId)
    return phaseLandingTabFor(target, aufgabeName)
  } catch {
    return defaultTab(target)
  }
}

export function useSwitchPhase() {
  const { state, dispatch } = useApp()
  return async (target: CoachingModal) => {
    const tab = await phaseLandingTab(target, state.screen?.coachingId ?? null)
    dispatch({ type: 'CHANGE_PHASE', target: { modal: target, tab } })
  }
}

export function useOpenPersonOverview() {
  const { dispatch } = useApp()
  return (coachingId: string, close?: () => void) => {
    close?.()
    dispatch({ type: 'OPEN_SCREEN', screen: { kind: 'personal', tab: 'uebersicht', coachingId } })
  }
}
